<script>
    import { getContext, setContext } from "svelte";
    import { onMount } from "svelte";
    export let menucacher;
    // let img = require("img/previous.png");
    let joueur = getContext("joueur");
    menucacher = true;
    let effetsonore = [new Audio("son/effet/validation3.mp3"), new Audio("son/effet/valider.mp3")];
    effetsonore[0].volume = 0.5;
    effetsonore[0].playbackRate = 2;
    let index = 0;
    let stages = [
        {
            titre: "Mission 1 : Welcome noob",
            image: "img/niveau1.png",
            description: "La mission parfaite pour les nouvelles recrues.",
            niveau: "Facile"
        },
        {
            titre: "Mission 2 : Warrior test",
            image: "img/niveau2.png",
            description: "Montre à la X13-Corp ta vrai valeur !",
            niveau: "Facile"
        },
        {
            titre: "Mission 3 : Challenge",
            image: "img/niveau3.png",
            description: "Seuls les meilleurs s'en sortiront...",
            niveau: "Moyen"
        },
        {
            titre: "Mission 4 : Boss",
            image: "img/niveau4.png",
            description: "Affronter Bramak n'est pas une mince affaire.",
            niveau: "Difficile"
        }
    ];
    onMount(async () => {});
</script>

{#if !menucacher}
    <div id="block">
        <img src="img/profil.png" alt="" id="titrestages" />
        {#key index}
            <p id="titre">{stages[index].titre}</p>
            <p id="score">{joueur.score[index]}</p>
            <p id="kills">{joueur.kill[index]}</p>
        {/key}
        <img src={stages[index].image} alt="" />
        {#key index}
            <p id="description">{stages[index].description}</p>
            <p id="niveau"><span>{stages[index].niveau}</span></p>{/key}
        <p
            id="previous"
            src="img/previous.png"
            alt=""
            on:click={() => {
                effetsonore[0].play();
                if (index === 0) {
                    index = 3;
                } else {
                    index--;
                }
            }}
        >
            <img src="/img/previous.png" alt="" id="previousimg" />
        </p>
        <p
            id="next"
            src="img/previous.png"
            alt=""
            on:click={() => {
                effetsonore[0].play();
                if (index === stages.length - 1) {
                    index = 0;
                } else {
                    index++;
                }
            }}
        >
            <img src="/img/next.png" alt="" id="nextimg" />
        </p>
    </div>
{/if}
<img
    alt="zones"
    src="img/menuzones.png"
    id="fermer"
    on:click={(e) => {
        if (menucacher === true) {
            effetsonore[1].volume = 0.05;

            effetsonore[1].play();
            menucacher = false;
        } else {
            menucacher = true;
        }
    }}
/>

<style>
    @keyframes text {
        from {
            transform: translatey(110px);
            opacity: 0;
        }
        to {
            transform: translatey(0px);
            opacity: 1;
        }
    }
    @keyframes scale {
        from {
            transform: scale(1);
        }
        to {
            transform: scale(1.5);
        }
    }
    @keyframes apparitioninfo {
        from {
            opacity: 0;
            transform: translateY(0px);
        }
        to {
            transform: translateY(-30px);
            opacity: 1;
        }
    }
    @keyframes apparitiontitre {
        from {
            opacity: 0;
            transform: translateX(-200px);
        }
        to {
            transform: translateX(0px);
            opacity: 1;
        }
    }
    #block {
        width: 1000px;
        height: 700px;
        background-color: rgb(0, 0, 0);
        position: absolute;
        display: flex;
        flex-direction: column;
        left: 50%;
        top: 50%;
        border: solid 1px rgb(0, 167, 179);
        transform: translate(-50%, -50%);
        border-radius: 3px;
        align-items: center;
        z-index: 4;
        box-shadow: 0px 0px 10px rgb(0, 0, 0), 0px 0px 10px #000000;
    }
    img {
        max-width: 100%;
    }
    #score {
        position: absolute;
        left: 12px;
        top: 45px;
        font-size: 12px;
    }
    #kills {
        position: absolute;
        left: 12px;
        top: 65px;
        font-size: 12px;
    }

    #previous {
        top: 50%;
        left: 10px;
        position: absolute;
        animation: scale 1s infinite alternate linear;
        box-shadow: 0px 0px 6px rgb(221, 0, 0);
        border-radius: 70%;
        background-color: rgb(0, 0, 0);
        border: solid 1px black;
        width: 20px;
        height: 20px;
        cursor: url("/img/mouse2.png"), pointer;
        color: rgb(255, 255, 255);
        user-select: none;
    }
    #previousimg {
        width: 70%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #nextimg {
        width: 70%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #next {
        top: 50%;
        right: 10px;
        position: absolute;
        animation: scale 1s infinite alternate linear;
        box-shadow: 0px 0px 6px rgb(221, 0, 0);
        border-radius: 70%;
        background-color: rgb(0, 0, 0);
        border: solid 1px black;
        width: 20px;
        height: 20px;
        cursor: url("/img/mouse2.png"), pointer;
        color: rgb(255, 255, 255);
        user-select: none;
    }
    #description {
        position: absolute;
        bottom: 4px;
        text-shadow: 1px 1px 9px rgb(0, 0, 0);
        font-size: 12px;
        animation: apparitioninfo 0.5s ease alternate forwards;
    }
    #niveau {
        position: absolute;
        top: 25%;
        right: 32px;
        color: greenyellow;
        text-shadow: 1px 1px 9px rgb(0, 0, 0);
    }
    #titre {
        color: rgb(255, 255, 255);
        text-shadow: 1px 1px 6px rgb(0, 233, 221);
        animation: apparitiontitre 1s ease forwards;
    }
    p {
        color: white;
    }
    #titrestages {
        position: absolute;
        top: 1.2px;
        width: 1000px;
        height: 700px;
    }
    #fermer {
        z-index: 5;
        position: absolute;
        width: 200px;
        top: 115px;
        left: 25px;
        display: initial;
        cursor: url("/img/mouse2.png"), pointer;
        color: rgb(246, 90, 0);

        border-radius: 9px;
        padding: 5px;
        font-size: 30px;
        text-shadow: 1px 1px 16px rgb(70, 0, 128);
        font-weight: 1900px;
    }
    #fermer:hover {
        color: rgb(247, 189, 0);
        font-size: 33px;
    }
</style>
